import React, { useEffect, useRef } from "react";
import { Row, Col, Button, Spinner } from "react-bootstrap";

export default function Intersect({ onIntersect, disabled, rootMargin = "0px", delay = 1000 }) {
    const ref = useRef();
    const timeoutRef = useRef();

    useEffect(() => {
        if (disabled) return;
        const observer = new window.IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    timeoutRef.current = setTimeout(() => {
                        onIntersect();
                    }, delay);
                }
            },
            { rootMargin }
        );
        if (ref.current) observer.observe(ref.current);
        return () => {
            observer.disconnect();
            clearTimeout(timeoutRef.current);
        };
    }, [onIntersect, disabled, rootMargin, delay]);

    return <div ref={ref}>
        <Row className="mb-3">
            <Col md={12} className="text-center">
                <Button variant="primary" onClick={onIntersect} >
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                    />
                    Loading...
                </Button>
            </Col>
        </Row>
    </div>;
}